import { Refresh } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import FilingPackageTable from "./FilingPackageTable";
import { useEffect, useState } from "react";
import { axios_tenant } from "../../../axios";
import { toast } from "react-toastify";

const FilingPackage371 = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadRequests = async () => {
    setLoading(true);
    axios_tenant
      .get("/reference-downloader/pctrequests")
      .then((response) => {
        setRequests(response.data);
      })
      .catch((error) => {
        toast.error("Failed to load requests");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loadRequests();
  }, []);

  return (
    <Box sx={{ px: { xs: 1, sm: 2, md: 3, lg: 5 } }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="h1">371 & Bypass Filing Package</Typography>
        <Button variant="outlined" startIcon={<Refresh />} disabled={loading} onClick={loadRequests}>
          Reload
        </Button>
      </Box>
      <FilingPackageTable loading={loading} requests={requests} loadRequests={loadRequests} setLoading={setLoading} />
    </Box>
  );
};

export default FilingPackage371;
